export default __webpack_public_path__ + "static/Artificial_Light_Indoor_2240kbps-33a3b176f73da1e0b0dab4cade11b3b0.avif";